export default __webpack_public_path__ + "static/media/1.9c8be371.png";